// Mutable state shared by the DOM intro timeline (App.jsx) and the 3D coins' frame loop.
// GSAP tweens these numbers; the WebGL scene reads them every frame — no React re-renders.
export const coinsState = {
  intro: 0, // 0 → 1: coins spin in after the photo intro
  scroll: 0, // 0 → 1 while the hero scrolls out
  pointer: { x: 0, y: 0 }, // -1..1 across the window
}
